import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import { StrategicAxis } from "./strategicAxis";
import styles from "./styles.scss";

function StrategicAxes({ strategicAxes }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.strategicAxes}>
      <div className={styles.header}>
        <h3 className={classNames(styles.label, styles.code)}>
          {t("strategicAxesPage.table.code")}
        </h3>
        <h3 className={classNames(styles.label, styles.name)}>
          {t("strategicAxesPage.table.strategicAxis")}
        </h3>
        <div className={styles.col}>
          <h3 className={styles.label}>
            {t("strategicAxesPage.table.strategicProjectAdequacy")}
          </h3>
          <div className={styles.row}>
            <h3 className={styles.label}>-2</h3>
            <h3 className={styles.label}>-1</h3>
            <h3 className={styles.label}>0</h3>
            <h3 className={styles.label}>1</h3>
            <h3 className={styles.label}>2</h3>
          </div>
        </div>
        <h3 className={classNames(styles.label, styles.weight)}>
          {t("strategicAxesPage.table.weight")}
        </h3>
        <div className={styles.contextualMenu} />
      </div>
      <div className={styles.strategicAxes}>
        {strategicAxes.map((strategicAxis) => (
          <StrategicAxis
            key={strategicAxis.uuid}
            strategicAxis={strategicAxis}
          />
        ))}
      </div>
    </div>
  );
}

export { StrategicAxes };
